import I18n from './I18n';
import FormattedMessageWithI18n from './comp/formattedMessageWithI18n/FormattedMessageWithI18n';
import FormattedCurrency from './comp/formattedCurrency/FormattedCurrency';

export default I18n;
export { FormattedMessageWithI18n };
export { FormattedCurrency };
